import { atomWithStorage, createJSONStorage } from "jotai/utils";

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
const utmStorage = createJSONStorage<any>(() => sessionStorage);

export interface UTMParameters {
	[key: string]: string | undefined;
}

export const utmParametersAtom = atomWithStorage<UTMParameters>(
	"utmParameters",
	{},
	utmStorage,
);
